import { render } from "./puissance_mecanique.vue?vue&type=template&id=37c18279&scoped=true&ts=true"
import script from "./puissance_mecanique.vue?vue&type=script&lang=ts"
export * from "./puissance_mecanique.vue?vue&type=script&lang=ts"

import "./puissance_mecanique.vue?vue&type=style&index=0&id=37c18279&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c18279"]])

export default __exports__